<template>
  <div id="app" v-bind:class="{zh: isLangEn, en: isLangZh}">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <!-- <div class="lang">
            <span v-on:click="switchLang('en')" v-if="isLangEn">EN</span>
            <span v-on:click="switchLang('zh')" v-if="isLangZh">中</span>
        </div> -->
        <header>
          <div class="container">
            <div class="logo"><router-link to="home"><img :src="`${publicPath}images/logo.png`"></router-link></div>
            <nav>
              <div class="ref">
                <a v-on:click="switchLang('zh')" v-bind:class="{ active: !isLangZh }" class="lang-switch">中</a>
                <a v-on:click="switchLang('en')" v-bind:class="{ active: !isLangEn }" class="lang-switch">EN</a>
                |
                <a href="https://www.abim.org/verify-physician.aspx?type=id&id=220021" target="_blank"><img :src="`${publicPath}images/icon-abim.png`" class="icon"></a>
                <a href="https://www.finddoc.com/en/doctors/raymond-tso-10074?dates=2019-07-22,2019-08-04" target="_blank"><img :src="`${publicPath}images/icon-finddoc.png`" class="icon"></a>
                <a href="https://www.facebook.com/GraceMedHK.DrRaymondTso/" target="_blank"><img :src="`${publicPath}images/icon-fb.png`" class="icon"></a>
                <a href="tel:+85228699981"><img :src="`${publicPath}images/icon-tel.png`" class="icon"></a>
              </div>

              <router-link :to="{ name: 'about' }">{{ $t("aboutGraceMed") }}</router-link>
              <router-link :to="{ name: 'our-doctor' }">{{ $t("ourHeadDoctor") }}</router-link>
              <router-link :to="{ name: 'services' }">{{ $t("services") }}</router-link>
              <router-link :to="{ name: 'news' }">{{ $t("news") }}</router-link>
              <router-link :to="{ name: 'contact-us' }">{{ $t("contactUs") }}</router-link>
              <!-- <div class="ref">
                <a href="https://www.finddoc.com/en/doctors/raymond-tso-10074?dates=2019-07-22,2019-08-04" target="_blank">FindDoc</a>
                <a href="https://www.facebook.com/GraceMedHK.DrRaymondTso/" target="_blank">Facebook</a>
              </div> -->
            </nav>

            <div class="mobile-nav">
              <a class="lang-switch" v-bind:class="{ active: !isLangEn }" v-on:click="switchLang('en')" >EN</a>
              <a class="lang-switch" v-bind:class="{ active: !isLangZh }" v-on:click="switchLang('zh')" >中</a>
              <div role="navigation">
                <div id="menuToggle" @click='toggleMobileNav()'>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>

              <div class="nav" v-show="mobileNav">
                <router-link :to="{ name: 'about' }">{{ $t("aboutGraceMed") }}</router-link>
                <router-link :to="{ name: 'our-doctor' }">{{ $t("ourHeadDoctor") }}</router-link>
                <router-link :to="{ name: 'services' }">{{ $t("services") }}</router-link>
                <router-link :to="{ name: 'news' }">{{ $t("news") }}</router-link>
                <router-link :to="{ name: 'contact-us' }">{{ $t("contactUs") }}</router-link>
                <div class="ref">
                  <a href="https://www.abim.org/verify-physician.aspx?type=id&id=220021" target="_blank">ABIM</a>
                  <a href="https://www.finddoc.com/en/doctors/raymond-tso-10074?dates=2019-07-22,2019-08-04" target="_blank">FindDoc</a>
                  <a href="https://www.facebook.com/GraceMedHK.DrRaymondTso/" target="_blank">Facebook</a>
                </div>
              </div>
            </div>
          </div>
        </header>
    <router-view/>
  </div>
</template>

<script>
import i18n from '@/components/i18n'

export default {
    name: 'App',
    data() {
        return {
            isLangZh: false,
            isLangEn: false,
            publicPath: process.env.BASE_URL,
            mobileNav: false
        }
    },
    created() {
        switch(i18n.locale) {
            case 'en':
                this.isLangEn = false;
                this.isLangZh = true;
                break;
            case 'zh':
                this.isLangEn = true;
                this.isLangZh = false;
                break;
        }
    },
    methods: {
        switchLang(newLang){
            i18n.locale = newLang
            localStorage.setItem('locale', newLang);
            switch(i18n.locale) {
                case 'en':
                    this.isLangEn = false;
                    this.isLangZh = true;
                    break;
                case 'zh':
                    this.isLangEn = true;
                    this.isLangZh = false;
                    break;
            }
        },
        toggleMobileNav() {
          this.mobileNav = !this.mobileNav
        }
    },
    watch: {
      '$route' () {
        this.mobileNav = false;
      }
    }
}
</script>

<style>
body {
  padding: 0;
  margin: 0;
}

#app {
  font-family: 'Raleway', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #75787b;
  font-size: 16px;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.container {
  width: 95%;
  max-width: 1125px;
  margin: auto;
}

header {
  width: 100%;
  height: 70px;
  position: fixed;
  background: #FFF;
  z-index: 1000;
}

header .logo img {
  max-width: 131px;
  width: 100%;
}

header .container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 100%
}

header nav a,
header nav div {
  display: inline-block;
  margin: 0 22px;
}

header nav {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}

header .ref {
  display: block;
  width: 100%;
  text-align: right;
  margin-bottom: 10px;
}

header .ref a {
  margin: 0 3px;
}

header nav .lang-switch {
  width: 20px;
  height: 20px;
  border: 1px solid #8a795f;
  margin: 0 3px;
  line-height: 20px;
  text-align: center; 
}

header nav .lang-switch.active {
  background: #8a795f;
  color: #FFF;
}

header nav .icon {
  width: 20px;
  vertical-align: middle;
}

/*header nav .ref {
  margin-top: -14px;
}

header nav .ref a {
  display: block;
  text-align: center;
  background: #8A795F;
  color: #FFF;
  padding: 2px 10px;
  margin: 2px;
  border-radius: 5px;
}
*/
header nav a {
  text-transform: uppercase;
  text-decoration: none;
  color: #85745f;
  font-weight: bold;
  font-size: 0.8em;
}

header nav a:hover,
header nav a.router-link-active,
header nav a.active {
  color: #f39d00;
}

footer {
  height: 90px;
  background: #9c8a72;
  display: block;
  color: #fff;
}

footer .container {
  position: relative;
}

footer .copyright {
  position: absolute;
  right: 0;
  top: 60px;
}

.banner {
  width: 100%;
  /*height: 515px;
  background: #808080;*/
  display: block;
  padding-top: 70px;
  position: relative;
  z-index: 10;
}

.banner h1 {
  position: absolute;
  color: #FFF;
  font-weight: bold;
  font-size: 3.5em;
  left:auto;
  bottom: 5%;
}

.banner h1 span {
  color: #f39d00;
}

.mobile-nav {
  display: none;
}

.mobile {
    display: none;
  }

  .desktop {
    display: block;
  }

@media handheld,only screen and (max-width: 800px) {
  .mobile {
    display: block;
  }

  .desktop {
    display: none;
  }

  .mobile-nav {
    display: block;
    display: flex;
    align-items: center;
  }

  header nav {
    display: none !important;
  }

  .mobile-nav .nav .ref a {
    text-align: center;
    background: #8A795F;
    color: #FFF;
    padding: 2px 10px;
    margin: 10px auto;
    border-radius: 5px;
    width: 90px;
  }

  header .container {
    width: 95%;
  }
  /* https://codepen.io/erikterwan/pen/EVzeRP */

  .mobile-nav .lang-switch {
    margin-top: -5px;
    margin: -8px 15px 0 0px;
    text-decoration: none;
    color: #75787b;
  }

  .mobile-nav .lang-switch.active {
    color: #e39200; 
  }

  #menuToggle
  {
    -webkit-user-select: none;
    user-select: none;
  }

  #menuToggle input
  {
    display: block;
    width: 40px;
    height: 32px;
    position: absolute;
    top: -7px;
    left: -5px;
    
    cursor: pointer;
    
    opacity: 0;
    z-index: 2;
    
    -webkit-touch-callout: none;
  }

  #menuToggle span
  {
    display: block;
    width: 33px;
    height: 4px;
    margin-bottom: 6px;
    position: relative;
    
    background: #e39200;
    border-radius: 1px;
    
    z-index: 1;
    
    transform-origin: 4px 0px;
    
    transition: transform 0.5s cubic-bezier(0.77,0.2,0.05,1.0),
                background 0.5s cubic-bezier(0.77,0.2,0.05,1.0),
                opacity 0.55s ease;
  }

  #menuToggle span:first-child
  {
    transform-origin: 0% 0%;
  }

  #menuToggle span:nth-last-child(2)
  {
    transform-origin: 0% 100%;
  }

  #menuToggle.active span
  {
    opacity: 1;
    transform: rotate(45deg) translate(-2px, -1px);
    background: #232323;
  }

  /*
   * But let's hide the middle one.
   */
  #menuToggle.active span:nth-last-child(3)
  {
    opacity: 0;
    transform: rotate(0deg) scale(0.2, 0.2);
  }

  /*
   * Ohyeah and the last one should go the other direction
   */
  #menuToggle.active span:nth-last-child(2)
  {
    transform: rotate(-45deg) translate(0, -1px);
  }

  .mobile-nav .nav {  
    position: absolute;
    top: 70px;
    left: 0;
    width: 100%;
    background: #FFF;
    padding: 20px 0;
  }

  .mobile-nav .nav a {
    width: 100%;
    text-align: center;
    display: block;
    padding: 10px 0;
    text-decoration: none;
    color: #85745f;
  }

  .mobile-nav .nav a.active,
  .mobile-nav .nav a.router-link-active,
  .mobile-nav .nav a:hover {
    color: #f39d00;
  }

  footer {
    height: auto;
  }

  footer .copyright {
    position: relative;
    top: 0;
    left:0;
    width: 100%;
    text-align: center;
    padding: 10px 0;
    font-size: 0.8em;
  }
}
</style>